import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { I18n } from 'common'
import { LaborRow } from './LaborRow'
import {
  StyledItemsTitle,
  CartTable,
  HeaderRow,
  ColHeader,
  StyledItemsLaborSpecsTitleWrapper,
} from '../SytledTable'
import { Vehicle } from '../../../../store/models/Vehicles'
import { useSelector } from 'react-redux'
import { RootState, store } from 'store'
import { getVehicleLabor } from 'cart'
import { cartSlice } from 'cart'
import { toJS } from 'mobx'

interface CartLaborItemsInterface {
  currentVehicle: Vehicle
}
export const CartLaborItems = observer(
  (props: CartLaborItemsInterface): ReactElement => {
    const { currentVehicle } = props
    const laborItems = useSelector((state: RootState) =>
      getVehicleLabor(state, currentVehicle)
    )

    const removeLabor = (laborId: number): void => {
      const filteredLabors = laborItems?.filter(
        (labor) => labor.laborId !== laborId
      )
      store.dispatch(
        cartSlice.actions.setVehicleLaborData({
          vehicle: toJS(currentVehicle),
          laborItems: toJS(filteredLabors),
        })
      )
    }
    if (laborItems?.length <= 0) {
      return null
    }
    return (
      <>
        <StyledItemsLaborSpecsTitleWrapper>
          <StyledItemsTitle>
            <I18n name="labor" />
          </StyledItemsTitle>
        </StyledItemsLaborSpecsTitleWrapper>
        <CartTable>
          <HeaderRow>
            <tr>
              <ColHeader>
                <I18n name="laborId" />
              </ColHeader>
              <ColHeader>
                <I18n name="description" />
              </ColHeader>
              <ColHeader>
                <I18n name="rate" />
              </ColHeader>
              <ColHeader>
                <I18n name="hours" />
              </ColHeader>
              <ColHeader>
                <I18n name="wtyHours" />
              </ColHeader>
              <ColHeader>
                <I18n name="skillLevel" />
              </ColHeader>
              <ColHeader>
                <I18n name="total" />
              </ColHeader>
              <ColHeader />
            </tr>
          </HeaderRow>
          <tbody>
            {laborItems.map((laborItem) => {
              return (
                <LaborRow
                  key={laborItem.laborId}
                  labor={laborItem}
                  removeLabor={removeLabor}
                />
              )
            })}
          </tbody>
        </CartTable>
      </>
    )
  }
)
